import React, { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';

export default function AdminSidebar() {
  const location = useLocation();
  const [expandedItem, setExpandedItem] = useState(null);

  const sidebarItems = [
    { id: 'dashboard', label: 'Dashboard', path: '/admin/dashboard' },
    { 
      id: 'retailer-management', 
      label: 'Retailer Management', 
      path: '/admin/retailer-management',
      hasSubmenu: true,
      submenu: [
        { id: 'retailers', label: 'Retailers', path: '/admin/retailers' },
        // { id: 'activity-log', label: 'Activity Log', path: '/admin/activity-log' }
      ]
    },
  ];

  const handleLogout = () => {
    localStorage.removeItem('admin_token');
    localStorage.removeItem('admin_data');
    window.location.href = '/admin/login';
  };

  return (
    <aside className="w-64 bg-white border-r border-gray-200 fixed h-full top-0 left-0 z-50">
      <div className="p-6">
        <Link to="/admin/dashboard" className="flex items-center gap-2 font-display font-bold text-xl tracking-tight text-gray-900">
          <span className="text-accent text-sm">✦</span>
          RoomViz<span className="text-accent2">AI</span>
        </Link>
      </div>
      
      <nav className="px-4 space-y-2">
        {sidebarItems.map((item) => {
          if (item.hasSubmenu) {
            const isExpanded = expandedItem === item.id;
            const isActive = item.submenu.some(sub => location.pathname === sub.path);
            return (
              <div key={item.id}>
                <button
                  onClick={() => setExpandedItem(isExpanded ? null : item.id)}
                  className={`w-full flex items-center justify-between gap-3 px-4 py-3 rounded-lg transition-all ${
                    isActive || isExpanded
                      ? 'bg-accent/10 text-accent font-medium'
                      : 'text-gray-600 hover:bg-gray-100 hover:text-gray-900'
                  }`}
                >
                  <span>{item.label}</span>
                  <svg
                    className={`w-4 h-4 transition-transform ${isExpanded ? 'rotate-180' : ''}`}
                    fill="none"
                    stroke="currentColor"
                    viewBox="0 0 24 24"
                  >
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 9l-7 7-7-7" />
                  </svg>
                </button>
                {isExpanded && (
                  <div className="ml-4 mt-2 space-y-1">
                    {item.submenu.map((subItem) => {
                      const isSubActive = location.pathname === subItem.path;
                      return (
                        <Link
                          key={subItem.id}
                          to={subItem.path}
                          className={`block w-full flex items-center gap-3 px-4 py-2 rounded-lg transition-all ${
                            isSubActive
                              ? 'bg-accent/10 text-accent font-medium'
                              : 'text-gray-600 hover:bg-gray-100 hover:text-gray-900'
                          }`}
                        >
                          <span>{subItem.label}</span>
                        </Link>
                      );
                    })}
                  </div>
                )}
              </div>
            );
          }
          
          const isActive = location.pathname === item.path;
          return (
            <Link
              key={item.id}
              to={item.path}
              className={`w-full flex items-center gap-3 px-4 py-3 rounded-lg transition-all ${
                isActive
                  ? 'bg-accent/10 text-accent font-medium'
                  : 'text-gray-600 hover:bg-gray-100 hover:text-gray-900'
              }`}
            >
              <span>{item.label}</span>
            </Link>
          );
        })}
      </nav>

      <div className="absolute bottom-0 left-0 right-0 p-4 border-t border-gray-200">
        <button
          onClick={handleLogout}
          className="w-full flex items-center gap-3 px-4 py-3 rounded-lg text-red-600 hover:bg-red-50 transition-all"
        >
          <span>Logout</span>
        </button>
      </div>
    </aside>
  );
}
